// extracted by mini-css-extract-plugin
module.exports = {"section":"_103a151b99--section--jeyGG","info":"_103a151b99--info--ib3JG"};